import * as React from "react";
const SvgCell20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M14 6v8H6V6h8ZM4 6v8H1v2h3v3h2v-3h8v3h2v-3h3v-2h-3V6h3V4h-3V1h-2v3H6V1H4v3H1v2h3Z",
      clipRule: "evenodd"
    })
  );
export default SvgCell20Px;
